import { DeliveryAddressForm } from '@/components/CmgFindAChipotleModal/CmgDeliveryAddressModal/cmg-delivery-address-modal';
import { OrderWithContext } from '@/models';
import { ServicesContainer } from '@/services';
import { AnalyticsEvent } from '../models';

export class SaveDeliveryAddressEvent implements AnalyticsEvent {
  name = 'SaveDeliveryAddressEvent';
  constructor(public readonly form: DeliveryAddressForm) {}
}
